import {
  useStringValidation,
  formatValidationResponse
} from "@web-components/compositions/useStringValidation";
import { SetupContext, watch, ref } from "@vue/composition-api";
import { NumericFieldProps } from "@web-components/types/NumericFieldProps";
import { UseStringValidationResponse } from "@web-components/types/UseStringValidationResponse";

export const useNumericFieldFunctions = (
  props: NumericFieldProps,
  context: SetupContext
) => {
  //Need to create ref from initial value to track validation issues
  const inputValue = ref(props.value || "");

  let validationResponse: UseStringValidationResponse;
  const {
    requiredError,
    setDirty,
    numericError,
    betweenError,
    valid
  } = (validationResponse = useStringValidation({
    inputRef: inputValue,
    required: true,
    numeric: true,
    range: {
      min: props.min,
      max: props.max
    }
  }));

  watch([inputValue, valid], ([_, valid]) => {
    context.emit("validation", formatValidationResponse(validationResponse));
  });

  const onKeyUp = (value: string) => {
    const newValue = parseInt(value);
    inputValue.value = newValue;
    context.emit("input", newValue);
  };

  return {
    requiredError,
    numericError,
    betweenError,
    setDirty,
    valid,
    onKeyUp,
    validationResponse,
    inputValue
  };
};
